/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PlatformTaskRequest {
    getFixupPrototypeFunction() { return PlatformTaskRequest.fixupPrototype; }

    static newInstance(model: Partial<PlatformTaskRequest>): PlatformTaskRequest {
        let obj = Object.assign(new PlatformTaskRequest(), model);
        PlatformTaskRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PlatformTaskRequest>): PlatformTaskRequest {
        if (!model) return null;
        return PlatformTaskRequest.newInstance(<PlatformTaskRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PlatformTaskRequest) {
        if (!obj) return;

        models.PlatformTaskRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PlatformTaskRequest): boolean {
        Object.setPrototypeOf(obj, PlatformTaskRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.properties) {
            models.PlatformTaskProperties.fixupPrototype(this.properties);
        }
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Platform related background tasks
     */
    task: models.PlatformTasks;

    /**
     * Task specific properties (number of days for backfill)
     */
    properties: models.PlatformTaskProperties;

}
